import { planSvgChecked, planSvgUnchecked, messageRotator } from '../helperFunctions';
import onePlatformGetServiceQualification from './onePlatformGetServiceQualification';
import AppState from '../../AppState';
/**
 * Assemble requirements for selecting from multiple address options.
 *
 * @param {Object} addressData
 *   The object containing the multiple addresses.
 */
const onePlatformGetMultipleServicesAvailable = (addressData) => {
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const addressCheckProgress = AppState.get('addressCheckProgress');
    addressCheckProgress.style.display = 'none';
    const { context } = drupalJsObjects;
    const multiAddressContainer = context.querySelector('#multiple-addresses');
    const multiAddressNext = context.querySelector('#multi-address-next');
    const multiAddressTile = context.querySelector('#multi-address-tile');
    const buttonGroupMultiAddresses = context.querySelector('#button-group-multi-addresses');
    if (multiAddressTile) {
        multiAddressTile.style.display = 'block';
    }
    if (buttonGroupMultiAddresses) {
        buttonGroupMultiAddresses.style.display = 'block';
    }
    if (addressData.length > 4) {
        multiAddressContainer.classList.add('multiple-addresses-scroll');
    }
    addressData.forEach((data, i) => {
        const address = document.createElement('div');
        address.innerHTML = `
      <p data-address-id="${i}">${data.composite}</p>
      <div class="plan-radio"></div>
    `;
        const selectedRadio = address.querySelector('.plan-radio');
        address.classList.add('multi-address-tile--confirmation');
        selectedRadio.innerHTML = planSvgUnchecked;
        if (i === 0) {
            address.classList.add('selected');
            selectedRadio.innerHTML = planSvgChecked;
        }
        address.onclick = event => {
            address.classList.add('selected');
            selectedRadio.innerHTML = planSvgChecked;
            const otherAddresses = Array.from(address.parentNode.children).filter(other => other !== address);
            otherAddresses.forEach(otherAddress => {
                otherAddress.classList.remove('selected');
                otherAddress.querySelector('.plan-radio').innerHTML = planSvgUnchecked;
            });
        };
        multiAddressContainer.appendChild(address);
    });
    multiAddressNext.onclick = (address) => {
        const selectedAddress = multiAddressContainer.querySelector('.selected p');
        const addressId = selectedAddress.getAttribute('data-address-id');
        const addressObject = addressData[addressId];
        const addressReconfirmed = AppState.get('addressConfirmed');
        addressReconfirmed.innerText = addressObject.composite;
        const currentlyConfirmed = context.querySelector('#address-confirmation-2');
        const displayedTile = context.querySelector('#multi-address-tile');
        // Update the display to move to the next step.
        currentlyConfirmed.appendChild(addressReconfirmed);
        const tileElements = displayedTile.querySelectorAll('.multi-address-tile--confirmation');
        tileElements.forEach((element) => element.remove());
        displayedTile.style.display = 'none';
        addressCheckProgress.style.display = 'block';
        messageRotator();
        onePlatformGetServiceQualification(addressObject);
    };
};
export default onePlatformGetMultipleServicesAvailable;
